import { useState, type ReactElement } from 'react';
import { MOTION_DURATIONS } from './tokens.js';

export interface DelayedLoaderProps {
  className?: string;
  testId?: string;
}

/** Shared application bootstrap indicator, visible from the first rendered frame. */
export function DelayedLoader({
  className,
  testId = 'delayed-loader',
}: DelayedLoaderProps): ReactElement {
  // The negative delay pins the hop phase to wall-clock time, so the coins hop
  // on seamlessly across loader remounts (screen swaps); each coin inherits it.
  // Computed once per mount: recomputing on re-render would shift a RUNNING
  // animation's timeline and visibly snap the hop.
  const [animationDelay] = useState(() =>
    `-${(globalThis.performance?.now() ?? Date.now()) % MOTION_DURATIONS.loader}ms`);
  return (
    <main
      className={['cards-delayed-loader', className].filter(Boolean).join(' ')}
      data-testid={testId}
      role="status"
      aria-label="Загрузка"
      aria-live="polite"
    >
      <div
        className="cards-delayed-loader-mark"
        aria-hidden="true"
        style={{ animationDelay }}
      >
        <span />
        <span />
        <span />
      </div>
    </main>
  );
}
